import React from 'react';
import styles from './report-result.module.scss';
import { Button } from 'antd';
const DeviceReportResult = props => {
    const { deviceMacInfo, hideSuccess = false, onCloseModal } = props;
    const deviceType = (deviceMacInfo === null || deviceMacInfo === void 0 ? void 0 : deviceMacInfo.deviceType) || '';
    const deviceTypeName = deviceType ? (deviceType === 'PERSONAL' ? '个人设备' : '企业设备') : '其它设备';
    if (!deviceMacInfo)
        return null;
    return (React.createElement("div", { className: styles.container },
        !hideSuccess ? (React.createElement(React.Fragment, null,
            ' ',
            React.createElement("div", { className: styles.successIconContainer },
                React.createElement("div", { className: styles.successIcon },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48", fill: "none" },
                        React.createElement("circle", { cx: "24", cy: "24", r: "21", fill: "#0FD683" }),
                        React.createElement("path", { d: "M15.9004 24L22.2644 30.364C22.2644 30.364 29.221 23.4073 33.9316 18.6967", stroke: "white", "stroke-width": "3", "stroke-linecap": "round", "stroke-linejoin": "round" })))),
            React.createElement("div", { className: styles.reportResult }, "\u7533\u62A5\u6210\u529F\uFF0C\u7B49\u5F85\u7BA1\u7406\u5458\u5BA1\u6279"))) : null,
        React.createElement("div", { className: styles.deviceRowInfo },
            React.createElement("div", { className: styles.deviceRowInfoTitle }, "\u8BBE\u5907\u7C7B\u578B\uFF1A"),
            React.createElement("div", { className: styles.deviceRowInfoVal }, deviceTypeName || '')),
        React.createElement("div", { className: styles.deviceRowInfo },
            React.createElement("div", { className: styles.deviceRowInfoTitle }, "\u8BBE\u5907\u540D\u79F0\uFF1A"),
            React.createElement("div", { className: styles.deviceRowInfoVal }, (deviceMacInfo === null || deviceMacInfo === void 0 ? void 0 : deviceMacInfo.deviceName) || '')),
        React.createElement("div", { className: styles.deviceRowInfo },
            React.createElement("div", { className: styles.deviceRowInfoTitle }, "\u8BBE\u5907\u7CFB\u7EDF\uFF1A"),
            React.createElement("div", { className: styles.deviceRowInfoVal },
                "\u684C\u9762\u7CFB\u7EDF\uFF08",
                (deviceMacInfo === null || deviceMacInfo === void 0 ? void 0 : deviceMacInfo.osName) || '',
                "\uFF09")),
        React.createElement("div", { className: styles.deviceRowInfo },
            React.createElement("div", { className: styles.deviceRowInfoTitle }, "\u8BBE\u5907\u7F16\u7801\uFF1A"),
            React.createElement("div", { className: styles.deviceRowInfoVal }, (deviceMacInfo === null || deviceMacInfo === void 0 ? void 0 : deviceMacInfo.macAddress.join(',')) || '')),
        React.createElement("div", { className: styles.actionBtns },
            React.createElement(Button, { type: "primary", onClick: () => {
                    onCloseModal && onCloseModal();
                } }, "\u6211\u77E5\u9053\u4E86"))));
};
export default DeviceReportResult;
